import { UserModel } from '@em/models/restapi/User.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class UserCollectionModel extends CollectionModel<UserModel> {
    public constructor() {
        super(UserModel);
    }
}
